import { useEffect, useState } from 'react';
import Alert from 'react-bootstrap/Alert';

function AlertDismissible({ is, msg }) {
    const [show, setShow] = useState(true);

    useEffect(() => {
        if (!show) return;

        const timer = window.setTimeout(() => setShow(false), 4000);
        return () => window.clearTimeout(timer);
    }, [show]);

    if (!show) return null;

    return (
        <Alert variant={is ? 'success' : 'danger'} dismissible={false}>
            <Alert.Heading>
                <i className="fa-solid fa-circle-check fa-beat-fade" /> {is ? 'Success' : 'Alert'}
            </Alert.Heading>
            <p>{msg}</p>
        </Alert>
    );
}

export default AlertDismissible;